<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0">Client Aging Detail Report</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcelFile()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          responsiveLayout="scroll"
          [value]="filterCustomerAgingDetailReportLists"
          styleClass="p-datatable-customers"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 1000]"
          [autoLayout]="true"
          [resizableColumns]="true"
          [paginator]="filterCustomerAgingDetailReportLists.length >= 50"
          (onFilter)="onFilter($event)"
          stripedRows
          [rowHover]="true"
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 310px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th>Invoice</th>
              <th>Sale Order</th>
              <th>Project Name</th>
              <th>Client Account</th>
              <th>Client</th>
              <th>Days Outstanding</th>
              <th>Bucket</th>
              <th>Inv Amt Usd</th>
              <th>Open Amt Usd</th>
              <th>Currency</th>
              <th>Invoice Amt</th>
              <th>Payments</th>
              <th>Open Amt</th>
              <th *ngIf="showDisputeColumn">Dispute</th>
              <th>NC</th>
              <th>BC</th>
              <th>BCID</th>
              <th *ngIf="!showDisputeColumn">Note</th>
              <th *ngIf="showDisputeColumn">Dispute Note</th>
              <th>Email Invoice Address</th>
              <th>Description</th>
              <th>Inv Date</th>
              <th>Due Date</th>
              <th>Payment Reference</th>
              <th>Client PO number</th>
              <th>Buyer</th>
            </tr>
            <tr>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="invoice"
                    id="invoice"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'invoice',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="salesOrder"
                    id="salesOrder"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'salesOrder',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="projectName"
                    id="projectName"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'projectName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customerAccount"
                    id="customerAccount"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customerAccount',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="customer"
                    id="customer"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'customer',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="daysOutstanding"
                    id="daysOutstanding"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'daysOutstanding',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="bucket"
                    id="bucket"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'bucket', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="dispute"
                    id="dispute"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'disputeD365',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="brandingConsultant"
                    id="brandingConsultant"
                    style="max-width: 200px"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'brandingConsultant',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th *ngIf="showDisputeColumn"></th>
              <th></th>
              <th>
                <!-- <input
              jniAutoCompleteBlocker
              name="InvDateDate"
              id="InvDateDate"
              class="date-filter"
              onfocus="(this.type='date')"
              onblur="if(!this.value) this.type='text'"
              (change)="onInvDateDateFilter($event)"
            /> -->
                <jni-date-filter
                  [dataList]="customerAgingDetailReportLists"
                  [columnName]="invDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th>
                <!-- <input
              jniAutoCompleteBlocker
              name="DueDateDate"
              id="DueDateDate"
              class="date-filter"
              onfocus="(this.type='date')"
              onblur="if(!this.value) this.type='text'"
              (change)="onDueDateDateFilter($event)"
            /> -->
                <jni-date-filter
                  [dataList]="customerAgingDetailReportLists"
                  [columnName]="dueDateColumn"
                  (emitCancelFilter)="clearFilter($event)"
                  (emitApplyFilter)="applyFilter($event)">
                </jni-date-filter>
              </th>
              <th></th>
              <th></th>
              <th>
                <div class="d-flex">
                  <input
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="buyer"
                    id="buyer"
                    style="max-width: 200px"
                    (input)="
                      dt.filter($any($event.target).value, 'buyer', 'contains')
                    "
                    placeholder=""
                    class="p-column-filter p-inputtext p-component" />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-customerAgingDetailReportList
            let-rowIndex="rowIndex">
            <tr class="p-selectable-row">
              <td>
                <a
                  class="link"
                  (click)="
                    getInvoiceReport(customerAgingDetailReportList.invoice)
                  ">
                  {{ customerAgingDetailReportList.invoice }}
                </a>
              </td>

              <td>
                <a
                  class="link"
                  (click)="
                    redirectToSaleorder(
                      customerAgingDetailReportList.salesOrder
                    )
                  ">
                  {{ customerAgingDetailReportList.salesOrder }}
                </a>
              </td>
              <td>
                {{ customerAgingDetailReportList.projectName }}
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClient(
                      customerAgingDetailReportList.customerAccount
                    )
                  ">
                  {{ customerAgingDetailReportList.customerAccount }}
                </a>
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToClient(
                      customerAgingDetailReportList.customerAccount
                    )
                  ">
                  {{ customerAgingDetailReportList.customer }}
                </a>
              </td>
              <td>{{ customerAgingDetailReportList.daysOutstanding }}</td>
              <td>
                {{ customerAgingDetailReportList.bucket }}
              </td>
              <td>
                {{
                  customerAgingDetailReportList.invAmountUSD | number: "1.2-2"
                }}
              </td>
              <td>
                {{
                  customerAgingDetailReportList.openAmountUSD | number: "1.2-2"
                }}
              </td>
              <td>
                {{ customerAgingDetailReportList.currency }}
              </td>
              <td>
                {{
                  customerAgingDetailReportList.invoiceAmount | number: "1.2-2"
                }}
              </td>
              <td>
                <a
                  class="link"
                  (click)="
                    redirectToCustomerSettle(
                      customerAgingDetailReportList.refRecId
                    )
                  ">
                  {{ customerAgingDetailReportList.payments | number: "1.2-2" }}
                </a>
              </td>
              <td>
                {{ customerAgingDetailReportList.openAmount | number: "1.2-2" }}
              </td>
              <td *ngIf="showDisputeColumn">
                {{ customerAgingDetailReportList.disputeD365 }}
              </td>
              <td>
                {{ customerAgingDetailReportList.nc }}
              </td>
              <td>
                {{ customerAgingDetailReportList.brandingConsultant }}
              </td>
              <td>
                {{ customerAgingDetailReportList.bcId }}
              </td>
              <td *ngIf="showDisputeColumn">
                {{ customerAgingDetailReportList.disputeNotesD365 }}
              </td>
              <td *ngIf="!showDisputeColumn">
                {{ customerAgingDetailReportList.note }}
              </td>
              <td>
                {{ customerAgingDetailReportList.invoiceEmailAddress }}
              </td>
              <td>
                {{ customerAgingDetailReportList.description }}
              </td>
              <td>
                {{ customerAgingDetailReportList.invDate | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ customerAgingDetailReportList.dueDate | date: "MM-dd-yyyy" }}
              </td>
              <td>
                {{ customerAgingDetailReportList.paymentReference }}
              </td>
              <td>
                {{ customerAgingDetailReportList.customerPONumber }}
              </td>
              <td>
                {{ customerAgingDetailReportList.buyer }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="30">No Data Found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      [isModal]="true"
      (closeEvent)="closeModalForClient()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="settlementDisplayModal"
  [displayModal]="settlementDisplayModal"
  (closeEvent)="clientSettlementcloseModal()">
  <h1 class="panelHeading">Client Settlement</h1>
  <div class="panelBody">
    <jni-customer-settlement
      [clientIdFromModal]="clientSettlementId"
      (closeSettlementEvent)="clientSettlementcloseModal()">
    </jni-customer-settlement>
  </div>
</jni-modal-stacker>
